import React from 'react';

const Rechart = () => {
    return (
        <div>
            
        </div>
    );
};

export default Rechart;
